import { Typography, useTheme } from "@mui/material";
import React, { FC } from "react";
import { useLocalization } from "../hooks/useLocalization";
import { LabeledTextField } from "./LabeledTextField";

interface TextFieldWithCounterProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  maxLength?: number;
  multiline?: boolean;
  fullWidth?: boolean;
  isDisabled?: boolean;
  error?: boolean;
  helperText?: string;
  rows?: number;
}

const MAX_CHARACTERS = 50;

export const TextFieldWithCounter: React.FC<TextFieldWithCounterProps> = ({
  value,
  onChange,
  onKeyDown,
  placeholder,
  maxLength = MAX_CHARACTERS,
  multiline = true,
  fullWidth = true,
  isDisabled = false,
  error = false,
  helperText,
  rows,
}) => {
  const { t } = useLocalization();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
  };

  return (
    <LabeledTextField
      InputProps={{
        endAdornment: (
          <TextFieldCounter
            maxLength={maxLength}
            multiline={multiline}
            value={value}
          />
        ),
      }}
      disabled={isDisabled}
      error={error}
      fullWidth={fullWidth}
      height={multiline ? "auto" : 48}
      helperText={helperText}
      inputProps={{ maxLength }}
      multiline={multiline}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      placeholder={
        placeholder ?? t("components.textFieldWithCounter.placeholder")
      }
      rows={rows}
      sx={{
        mb: 0,
        "& .MuiInputBase-root": {
          fontSize: { sx: "16px", md: "14px" },
          fontWeight: 500,
        },
      }}
      value={value}
    />
  );
};

export const TextFieldCounter: FC<{
  value: string;
  maxLength: number;
  multiline?: boolean;
}> = ({ value, maxLength, multiline }) => {
  const theme = useTheme();

  return (
    <Typography
      sx={{
        fontWeight: 500,
        fontSize: "14px",
        color: theme.colors.text[0],
        height: 20,
        alignSelf: multiline ? "flex-end" : "center",
        pl: 1,
        whiteSpace: "nowrap",
      }}
    >
      {value.length}/{maxLength}
    </Typography>
  );
};
